module.exports = "/365FarmNet/dist/supplyTableSupplies.e0805226bbf524e3592dcd966165c090.html";